import {
  Button,
  ButtonGroup,
  Col,
  Container,
  Form,
  Row,
  Spinner,
} from "react-bootstrap";
import React, { useState } from "react";
import toast from "react-hot-toast";
import Packages from "../CreateUser/Packages";
import Numbers from "../CreateUser/Numbers";
import axiosInstance from "../../api/axiosInstance";

const EditUser = ({ handleClose, user, setIsNewUserAdded }) => {
  const [activeButton, setActiveButton] = useState("Packages");
  const [formData, setFormData] = useState({
    assignNumber: user.assignNumber || [],
    email: user.email || "",
    firstName: user.firstName || "",
    lastName: user.lastName || "",
    paymentPackage: user.paymentPackage || {
      packageName: "BasicUK",
      price: "5",
      quantity: "1",
    },
    paymentStatus: user.paymentStatus || true,
    phone: user.phone || "",
  });
  const [loading, setLoading] = useState(false);

  const { token } = JSON.parse(localStorage.getItem("auth"));

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axiosInstance.put(
        "/user/updateUserProfile",
        { ...formData, id: user._id },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        handleClose();
        setIsNewUserAdded(true);
        toast.success(response.data.message);

        response.data.twilioResponse.forEach((res) => {
          if (res.status === "rejected")
            toast.error(`${res.phoneNumber} ${res.reason}`);
        });
      }
    } catch (error) {
      console.error("Error updating user:", error);
      toast.error(error.response?.data?.message || "Unable to update user!");
    } finally {
      setLoading(false);
      setIsNewUserAdded(false);
    }
  };

  return (
    <>
      <Container>
        <Row className="justify-content-md-center">
          <Col md={6}>
            <h2 className="text-center mb-4">Edit User</h2>
            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-3" controlId="firstName">
                <Form.Label>First Name</Form.Label>
                <Form.Control
                  name="firstName"
                  onChange={handleChange}
                  placeholder="Enter first name"
                  required
                  type="text"
                  value={formData.firstName}
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="lastName">
                <Form.Label>Last Name</Form.Label>
                <Form.Control
                  name="lastName"
                  onChange={handleChange}
                  placeholder="Enter last name"
                  required
                  type="text"
                  value={formData.lastName}
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="email">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  name="email"
                  onChange={handleChange}
                  placeholder="Enter email"
                  required
                  type="email"
                  value={formData.email}
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="phone">
                <Form.Label>Phone Number</Form.Label>
                <Form.Control
                  name="phone"
                  onChange={handleChange}
                  placeholder="Enter phone number"
                  required
                  type="tel"
                  value={formData.phone}
                />
              </Form.Group>
              <ButtonGroup className="mb-3 w-100">
                <Button
                  className={activeButton === "Packages" ? "primaryBtn" : ""}
                  onClick={() => setActiveButton("Packages")}
                  variant={
                    activeButton !== "Packages" ? "secondary" : "primary"
                  }
                >
                  Packages
                </Button>
                <Button
                  className={activeButton === "Numbers" ? "primaryBtn" : ""}
                  onClick={() => setActiveButton("Numbers")}
                  variant={activeButton !== "Numbers" ? "secondary" : "primary"}
                >
                  Numbers
                </Button>
              </ButtonGroup>
              {activeButton === "Packages" ? (
                <Packages formData={formData} setFormData={setFormData} />
              ) : (
                <Numbers formData={formData} setFormData={setFormData} />
              )}
              <Row className="mt-3">
                <Col>
                  <Button
                    className="w-100"
                    disabled={loading}
                    onClick={handleClose}
                    type="button"
                    variant="danger"
                  >
                    Cancel
                  </Button>
                </Col>
                <Col>
                  <Button
                    className="w-100"
                    disabled={loading}
                    type="submit"
                    variant="success"
                  >
                    Update
                  </Button>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
      </Container>

      {loading && (
        <div
          style={{
            alignItems: "center",
            backgroundColor: "rgba(0, 0, 0, 0.75)",
            display: "flex",
            height: "100vh",
            justifyContent: "center",
            left: 0,
            position: "fixed",
            top: 0,
            width: "100vw",
            zIndex: 1000,
          }}
        >
          <Spinner
            animation="border"
            style={{
              borderWidth: 8,
              height: 100,
              width: 100,
            }}
            variant="light"
          />
        </div>
      )}
    </>
  );
};

export default EditUser;
